export const CATEGORY_FORM_ADD_PEOPLE_TEXT = 'Tags peoples';
export const CATEGORY_FORM_ADD_PEOPLE_SEARCHBAR_PLACEHOLDER =
  'Rechercher des peoples';
export const CATEGORY_FORM_ADD_PEOPLE_TAGS_MAX_QUANTITY = 30;
